/* eslint-disable camelcase */
<template >
  <div v-role="'func'">
    <br>
    <div>
      <div class="formPosition">         
          <!-- ======================== DIALOGO REGISTRAR BOLSEIRO ===================================== -->
          <v-dialog v-model="cardBolseiro" max-width="600px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Bolseiro</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas" item-value="listaOngBolsas" item-text="nome" return-object label="Organização:" @change="SelecionarOrganizacao()">
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                            <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.nome"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="tipoBolseiroSelected" :disabled="true" label="Tipo de bolseiro: "></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="valorDesconto" :disabled="true"  label="Valor do desconto"></v-combobox>
                    </v-col>
                  </v-row>
                  <p v-if="descricaoBolseiro">*{{ descricaoBolseiro }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="fecharCardBolseiro()"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()"> salvar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>





           <!-- ======================== DIALOGO REGISTRAR BOLSEIRO ===================================== -->
          <v-dialog v-model="cardBolseiro" max-width="600px">
            <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Bolseiro</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <v-combobox :rules="ruleRequired" v-model="ongBolsaSelected" :items="listaOngBolsas" item-value="listaOngBolsas" item-text="nome" return-object label="Organização:" @change="SelecionarOrganizacao()">
                        <template v-slot:item="{ item }">
                          <v-list-item-avatar v-if="item.icone" color="indigo" class="headline font-weight-light white--text">
                            <v-btn icon fab><v-icon style="color:white;">add</v-icon></v-btn>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.nome"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="tipoBolseiroSelected" :disabled="true" label="Tipo de bolseiro: "></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6" v-if="mostrarOpcoesBolsa">
                      <v-combobox v-model="valorDesconto" :disabled="true"  label="Valor do desconto"></v-combobox>
                    </v-col>
                  </v-row>
                  <p v-if="descricaoBolseiro">*{{ descricaoBolseiro }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="black darken-1" text @click="fecharCardBolseiro()"> fechar </v-btn>
                  <v-btn color="green darken-1" text :disabled="!valid" @click="verificarBolseiroCadastrado()"> salvar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>

          <!-- ======================== SECTION -> NOVA ORGANIZAÇÃO ============================================= -->


          
          <template>
            <v-row justify="center">
              <v-dialog v-model="cardNovaOrganizacao" persistent max-width="500px">
                <v-card>
                  <v-overlay :value="overlayOrganizacao">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                  <v-card-title>
                    <span class="headline">Nova Organização</span>
                  </v-card-title>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="nomeNovaOrganizacao" label="Forneça o nome da nova organização"></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-combobox :rules="ruleRequired" v-model="idNovaOrganizacao" :items="tipoBolseiroOng" item-value="tipoBolseiroOng" item-text="descricao" return-object label="Tipo de bolseiro:" >
                              <template v-slot:item="{ item }">
                                <v-list-item-content>
                                  <v-list-item-title v-text="item.descricao"></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </v-combobox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-form>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn style="color:white;" color="green darken-1" :disabled="!valid" @click="verificarOrganizacao()">Guardar</v-btn>
                    <v-btn @click="fecharCardNovaOrganizacao()">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ========================================== FIM NOVA ORGANIZAÇÃO ============================================ -->


          <!-- ======================== DIALOGO NOVO ESTUDANTE ===================================== -->
             <v-card>
              <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
              </v-overlay>
              <v-card-title style="background-color:#006699;color:white;border:1px solid #fff;">
                <span class="text-h5">Registrar Novo Estudante</span>
              </v-card-title>

              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" md="3" v-if="isAtlantidaOrMazozo">
                      <v-text-field :rules="ruleNumber" v-model="editedItem.numeroProcesso" label="Nº Processo"></v-text-field>
                    </v-col> -->

                    <v-col cols="12" md="3">
                      <v-text-field v-if="editarDados" required :rules="ruleBI" :disabled="true" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                      <v-text-field  v-if="!editarDados" required :rules="ruleBI" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                    </v-col>
                    <v-col v-if="!editarDados" cols="12" md="2">
                      <v-switch @change="outroDoc()"></v-switch>
                    </v-col>

                    <v-col cols="12" md="3">
                      <template>
                        <v-menu ref="menubi" :rules="ruleTextRequired" v-model="menubi" :close-on-content-click="false" transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="editedItem.dataemissaobi" :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de emissâo do BI" prepend-icon="event" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker ref="picker" max="2027-12-31" min="1950-01-01" v-model="datebi" @change="saveDatebi"></v-date-picker>
                        </v-menu>
                      </template>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-text-field :rules="ruleTextRequired" v-if="false" v-model="editedItem.pkPessoa" label="chave primaria auto increemente"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.nomedopai" label="Filho de:"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field v-model="editedItem.nomedamae" label=" e de:"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <template>
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y full-width min-width="290px">
                          <template v-slot:activator="{ on }">
                            <v-text-field v-model="editedItem.datanascimento" :rules="[v => !!v || 'Campo obrigatorio!']" label="Data de nascimento" prepend-icon="event" readonly v-on="on"></v-text-field>
                          </template>
                          <v-date-picker ref="picker" v-model="date" max="2022-12-31" min="1950-01-01" @change="saveDate"></v-date-picker>
                        </v-menu>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox :rules="ruleRequired" v-model="editedItem.provincia" :items="provincias" item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb" @click="loadMunicipioComb" return-object label="Natural de:"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox :rules="ruleRequired" v-model="editedItem.municipio" :items="municipiosFiltered" item-value="idMunicipio" item-text="descricao" return-object label="Municipio"></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox v-model="editedItem.sexo" :rules="ruleRequired" item-value="idSexo" item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                    </v-col>
                  </v-row>
                  <v-row>

                    <v-col cols="12" v-if="!editarDados" :md="(nivelEnsino === 1) ? '4' : '4'">
                      <v-combobox v-if="true" v-model="editedItem.curso" :rules="ruleRequired" item-value="idCurso" item-text="descricao" @change="loadclasse" :items="cursos" chips label="Curso"></v-combobox>
                    </v-col>

                    <v-col cols="12" v-if="!editarDados" :md="(nivelEnsino === 1) ? '4' : '4'">
                      <v-combobox v-model="editedItem.classeSelected" :rules="ruleRequired" item-text="descricao" :items="classesFiltered" @change="loadTurmaComb" chips :label="(nivelEnsino === 1) ? 'Selecione o ano académico' : 'Selecione a classe'" return-object></v-combobox>
                    </v-col>
                     <v-col cols="12" v-if="!editarDados" :md="(nivelEnsino === 1) ? '4' : '4'">
                      <v-combobox  id="turma"
                          v-model="editedItem.turma"
                          :rules="ruleRequired"
                          :value="undefined"
                          item-value="idTurma"
                          item-text="turmadescricao"
                          :items="turmasFiltered"
                          chips
                          label="Turma"
                          @change="ObterNumeroEstudantesTurma()"
                        ></v-combobox>
                     </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox v-if="!editarDados" v-model="editedItem.periodo" :rules="ruleRequired" item-value="id" item-text="descricao" :items="periodos" chips label="Período"></v-combobox>
                    </v-col>
                    <v-col md="8" v-if="editedItem.turma !== null">
                       <v-row>
                        <v-card
                          max-width="300px"
                          class="margin-card"
                        >
                          <v-card-text>
                            <v-row>
                                  <v-col md="12">
                                  <span class="boldText">Capacidade da Turma: </span>
                                  <span>{{this.editedItem.turma.capacidade}}</span>
                                  </v-col>
                                  <v-col md="12">
                                  <span class="boldText">Nº Estudantes na Turma: </span>
                                  <span>{{(numeroEstudantesCadastrado.length)?numeroEstudantesCadastrado[0].qtdEstudante:0}}</span>
                                  </v-col>
                                  <v-col md="12">
                                  <span class="boldText">Vagas disponíveis: </span>
                                  <span :style="(vagasDisponiveis > 0)?'color:green;font-weight:bold;':'color:red;font-weight:bold;'">{{vagasDisponiveis}}</span>
                                  </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                        </v-row>
                    </v-col>
                    <!-- <v-col v-if="nivelEnsino !== 1" cols="12" md="5">
                      <v-combobox 
                        v-model="editedItem.turma"
                        :rules="ruleRequired"
                        item-text="descricao"
                        :items="turmasFiltered"
                        chips
                        label="Selecione a turma"
                        return-object
                      ></v-combobox>
                    </v-col> -->
                  </v-row>
                  <small>*Preencha correctamente os campos</small>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text :disabled="!valid || vagasDisponiveis <=0" @click="Guardar()"> Guardar </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
           <!-- =================================================================================================== -->

          <!-- =================================================================================================== -->
          <v-row justify="center">
            <v-dialog v-model="dialogoConcordar" persistent max-width="490">
              <v-card>
                <v-card-title class="headline">Desejas continuar com essa operação?</v-card-title>
                <v-card-text>Essa operação irá afectar o sistema como um todo, por isso pergunto novamente tens realmente a certeza de que desejas continuar com essa operação?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click="dialogoConcordar = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" text @click="MudarTipoEstudante()">Concordar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
          <!-- **************************************************************************************************** -->
      </div>
    </div>
  </div>
</template>
My CRUD
<script>
import axios from '../../../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../../../plugins/utilitarios'
import impressaoUtilitario from '../../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    cardBolseiro: false,
    editarDados:false,
    mostrarOpcoesBolsa: false,
    tipoDeBolsa: '',
    descricaoBolseiro: '',
    tipoBolseiroOng: [],
    cardNovaOrganizacao: false,
    overlayOrganizacao: false,
    nomeNovaOrganizacao: '',
    idNovaOrganizacao: null,
    bolseiroSelected: null,
    valorDesconto: '',
    tipoBolseiroSelected: '',
    listaOngBolsas: [],
    ongBolsaSelected: null,
    showConfirmacao: false,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    allowSpaces: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    periodos: [
      { id: 'M', descricao: 'Manhã' },
      { id: 'T', descricao: 'Tarde' },
      { id: 'N', descricao: 'Noite' }
    ],
    datebi: null,
    date: null,
    novo: false,
    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    servico: '',
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    produtos: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    searchInDb: '',
    estudantes: [],
    classes: [],
    classesFiltered: [],
    turmasAll: [],
    recibos: [],
    servicos: [],
    dialogGrupo: false,
    dialogTaxa: false,
    dialog: false,
    idd: false, // simula autoinclemet
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value => (value || '').length <= 70 || 'O máximo número de carácters atigidos',
      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [
      value => !!value || 'campo obrigatório.',
      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Bi', value: 'bi' },
      { text: 'Matrícula', value: 'idMatricula' },
      { text: 'Curso', value: 'curso_descricao' },
      { text: 'Bolseiro', value: 'bolseiro'},
      { text: 'Classe', value: 'classe' },
      { text: 'Data registro', value: 'data_cadastro' },
      { text: 'Autor', value: 'autor' },
      { text: 'Action', value: 'action' }
    ],
    msg: '',
    config: null,
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    overlay: false,
    numeroEstudantesCadastrado: [],
    estudanteObjecto: null,
    dialogoConcordar: false,
    editedItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      periodo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:''
    },
    defaultItem: {
      pk_estudante:0,
      numeroProcesso: '',
      pkPessoa: 0,
      classeSelected: '',
      bi: '',
      idPessoa: '',
      municipio: null,
      idPerfil: null,
      nome: '',
      periodo: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      numeroProcesso: null,
      dataemissaobi: null,
      provincia: null,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      numeroProcesso: '',
      matriculaAntiga:'',
    }
  }),

  computed: {

    vagasDisponiveis(){
      return parseInt((this.editedItem.turma === null || this.editedItem.turma == undefined)?0:this.editedItem.turma.capacidade) - parseInt((this.numeroEstudantesCadastrado.length)?this.numeroEstudantesCadastrado[0].qtdEstudante:0)
    },

    loggedUserName() {
      return ls.get('nomeUsuario')
    },
    computeddatanascimento() {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns() {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    nivelEnsino() {
      return ls.get('nivel')
    },
    role() {
      return ls.get('role')
    },
    isAtlantidaOrMazozo() {
      return true//window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10') || window.location.host.includes('ispamazozo.com')
    }
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes() {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize();
    this.carregarDadosBolseiros();
    this.initializeProvincias();
    this.initializeMunicipios();
    this.initializeCursos();
    this.initializeturmasAll()
    this.config = impressaoUtilitario.getConfig()
    this.getUrlImpressao()
    if (this.nivelEnsino !== 1) {
      this.initializeClasses();
    }
  },

  methods: {
    async getUrlImpressao () {
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url)
      } catch (error) {
        console.log(error)
      } finally {
      }
    },

    async initializeturmasAll () {
    //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + this.idclasse)
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initialize() {
      try {
        this.progresso = true;
        this.produtos = await axios.get('/estudantesFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeProvincias() {
      try {
        this.progresso = true;
        this.provincias = await axios.get('/provinciaFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },


    async imprimirFichaConfirmacao (item) {
      try {
        this.overlay = true
        let infoEstudante = await this.ObterHistoricoAcademico({idMatricula:item.idMatricula}).then((res)=>res.data)
        this.comporHtml(infoEstudante[0])
        this.overlay = false
      } catch (error) {
        this.overlay = false
      }    
    },

    async comporHtml (estudante) {
      try {
        this.html = `
<html>
<head>
<style>
  body {font-family: Arial, sans-serif;}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 0px;
  font-family: Arial, sans-serif;
}
.heading td { border: 1px solid #ddd;}
.centerColumn {
  text-align: center;
  padding: 16px;
}

.wordcenter {text-align:center;}
.titulo { font-size:14px;font-weight:bold;}
.titulo2 { font-size:12px;font-weight:bold;}
.table2 td{ font-size:12px;text-align:left;}
.heading2 td{ font-size:12px;border: 1px solid #ddd;}
.heading3 td{ font-size:12px;text-align:center;}
.distanciaEntrelinhas {padding: 10px 0px 10px 0px;}
.distanciaEntrelinhasDadosPessoais {padding: 5px 0px 5px 0px;}
.borda { border:1px solid #000;}
.bordaBottom { border-bottom:1px solid #000;}
.bordaTop { border-top:1px solid #000;}
.negrito { font-weight:bold;}
.larguraInquerito1 {width:30%;}
.larguraInquerito2 {width:70%;}

.versoTable td{ font-size:12px;line-height:30px;}
.frenteVerso {margin-top:150px;}
div.groove {border-style: groove;padding:0px 8px 0px 8px;}
</style>
</head>
<body>
  
    <table class="heading">
       <tr>
    <td align="center" rowspan="2"><img height="92px" src="data:image/jpeg;base64,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"/></td>
    <td rowspan="2" style="border:0px;"></td>
    <td class="centerColumn titulo" style="border-bottom:0px;">Instituto Técnico Privado de Saúde Ilha da verdade</td>
     </tr>
     <tr> <td class="centerColumn titulo2" style="border-top:0px;">FICHA DE MATRÍCULA E CONFIRMAÇÃO DE MATRÍCULA</td></tr>
    </table>
 <br>
 <table class="heading2">
       <tr>
          <td style="border-right:0px;border-bottom:0px;">PREENCHER PELA SECRETARIA</td>
          <td style="border-left:0px;border-bottom:0px;">Nº do Processo:______________________</td>
          <td rowspan="2" style="border:0px;"></td>
          <td align="center" rowspan="2"><img height="92px"/></td>
    
     </tr>
     <tr> 
       <td style="border-right:0px;border-top:0px;">TÉCNICO-PROFISSIONAL</td>
       <td style="border-left:0px;border-top:0px;">[X] `+estudante.classe+`</td>
     </tr>
    </table>

    <table class="heading3">
      <tr>
        <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] MATRÍCULA</td>
        <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] CONFIRMAÇÃO</td>
      </tr>
    </table>
 
 
<h5>DADOS PESSOAIS DO ALUNO</h5>
<table class="table2">
  <tr><td colspan="2">Nome do(a) Aluno(a): <span style="font-weight:bold;text-decoration:underline;">`+estudante.nome+`</span></td></tr>
  <tr><td colspan="2" class="distanciaEntrelinhasDadosPessoais"></td></tr>
  <tr><td colspan="2">Nascido aos `+this.retornaData(estudante.datanascimento)+`,no município <span style="font-weight:bold;text-decoration:underline;">`+estudante.municipio+`</span>, na província <span style="font-weight:bold;text-decoration:underline;">`+estudante.provincia+`</span></td></tr>
  <tr><td colspan="2" class="distanciaEntrelinhasDadosPessoais"></td></tr>
  <tr> <td colspan="2">Residente em, <span style="font-weight:bold;text-decoration:underline;">`+estudante.provincia+`</span></td> </tr>
  <tr><td colspan="2" class="distanciaEntrelinhasDadosPessoais"></td></tr>
  <tr><td colspan="2">portador de Bilhete, nº <span style="font-weight:bold;text-decoration:underline;">`+estudante.bi+`</span> Arquivo de <span style="font-weight:bold;text-decoration:underline;">`+estudante.provincia+`</span>, aos <span style="font-weight:bold;text-decoration:underline;">`+this.retornaData(estudante.dataemissaobi)+`</span></td></tr>

  <tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
   <tr><td colspan="2"><h5>SITUAÇÃO DO ANO LECTIVO ANTERIOR</h5></td></tr>
   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Frequentou o ano lectivo <span style="font-weight:bold;">`+(ls.get('anolectivo')-1)+`</span>, a turma <span style="font-weight:bold;text-decoration:underline;">_________________</span> da <span style="font-weight:bold;text-decoration:underline;">_________________</span> ª classe na instituição <span style="font-weight:bold;text-decoration:underline;">_________________________________________</span></td></tr>
   <tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
   <tr> 
     <td colspan="2" class="bordaTop"> 
    [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] O aluno está sinalizado como Necessidades Educativas Especiais.<br>
    (Em  caso de resposta afirmativa, anexar Relatório Médico). 
    </td> 
   <td></td> 
   </tr>
<tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="2"><h5>SITUAÇÃO PARA O ANO LECTIVO <span style="font-weight:bold;">`+ls.get('anolectivo')+`</span></h5></td></tr>
    <tr><td colspan="2">No presente ano lectivo, pretende matricular-se na <span style="font-weight:bold;">`+estudante.classe+`</span> <span style="font-weight:bold;">`+estudante.curso+`</span> - `+estudante.turma+`.</td></tr>
   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Em caso de necessidade, autorizo o aluno a ser  observado pela Equipa de Intervenção Multidisciplinar.</td></tr>
   <tr><td colspan="2"><h5>Para as ofertas abaixo informe-se junto da Secretaria do Preço e das Condições de acesso e preencha os respectivos formulários.</h5></td></tr>


   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Pretende transporte escolar.</td></tr>
   <tr><td colspan="2">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Pretende frequentar o A.T.L/[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Aulas de Reforço.</td></tr>
<tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
   <tr><td colspan="2"><h5>INQUÉRITO DE SAÚDE (Riscar o que não interessa ou acrescentar informação)</h5></td></tr>
   <tr>
     <td class="distanciaEntrelinhas larguraInquerito1">Alergia: Não [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Sim [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Se sim, quais: </td>
     <td class="bordaBottom distanciaEntrelinhas larguraInquerito2"></td>
    </tr>
   <tr>
     <td class="distanciaEntrelinhas larguraInquerito1">Cuidados Especiais de </td>
     <td class="bordaBottom distanciaEntrelinhas larguraInquerito2"></td>
   </tr>
   <tr>
     <td class="distanciaEntrelinhas larguraInquerito1">Doenças crónicas: Não [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Sim [&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Se Sim, quais:</td>
     <td class="bordaBottom distanciaEntrelinhas larguraInquerito2"></td>
   </tr>
   <tr>
     <td class="distanciaEntrelinhas">[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Em caso de febre poderá ser administrado: ben-u-ron, xarope, supositórios, </td>
     <td class="bordaBottom distanciaEntrelinhas"></td>
   </tr>
    <tr><td colspan="2" class="bordaBottom distanciaEntrelinhas"></td></tr>
    <tr>
      <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] O aluno tem a seguinte restrição ou alergia alimentar:</td>
      <td class="bordaBottom"></td>
    </tr>
     <tr><td colspan="2" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="2" class="distanciaEntrelinhas borda"></td></tr>
</table>
<div class="frenteVerso"></div>
<div class="groove">
<table class="versoTable">
  <tr><td class="wordcenter titulo" colspan="3">DADOS PESSOAIS DOS PAIS E DO ENCARREGADO DE EDUCAÇÃO</td></tr>
  <!-- Pai -->
  <tr><td colspan="3">Pai <span style="font-weight:bold;text-decoration:underline;">`+estudante.nomedopai+`</span> </td></tr>
  <tr>
    <td>Estado Civil __________________________</td>
    <td>Naturalidade __________________________</td>
    <td>Residente em __________________________</td>
    </tr>
    <tr>
    <td>Telefone </td>
    <td colspan="2">Email __________________________</td>
    </tr>
    <tr>
    <td>Profissão </td>
    <td colspan="2">Local de trabalho __________________________</td>
    </tr>
    <!-- Mãe -->
    <tr><td colspan="3">Mãe <span style="font-weight:bold;text-decoration:underline;">`+estudante.nomedamae+`</span></td></tr>
  <tr>
    <td>Estado Civil __________________________ </td>
    <td>Naturalidade __________________________ </td>
    <td>Residente em __________________________ </td>
    </tr>
    <tr>
    <td>Telefone __________________________ </td>
    <td colspan="2">Email __________________________ </td>
    </tr>
    <tr>
    <td>Profissão __________________________ </td>
    <td colspan="2">Local de trabalho __________________________</td>
    </tr>
    <!-- Encarregado de educação -->
     <tr>
    <td colspan="1" style="font-weight:bold;">Encarregado de Educação</td>
    <td>Grau de Parentesco </td>
    <td><span style="font-weight:bold;text-decoration:underline;">Pai</span> </td>
    </tr>
    <tr><td colspan="3">(Se pai ou mãe não precisa de preencher mais nenhuma informação)</td></tr>
     <tr>
    <td>Estado Civil </td>
    <td>Naturalidade </td>
    <td>Residente em </td>
    </tr>
    <tr>
    <td>Telefone </td>
    <td colspan="2">Email </td>
    </tr>
    <tr>
    <td>Profissão </td>
    <td colspan="2">Local de trabalho </td>
    </tr>
    
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="titulo">Documentos Entregues</td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="distanciaEntrelinhas"></td></tr>
    <tr><td colspan="3" class="wordcenter titulo2">TERMO DE RESPONSABILIDADE</td></tr>
    <tr><td colspan="3">Eu, <span style="font-weight:bold;text-decoration:underline;">`+estudante.nomedopai+`</span>, Encarregado de Educação do(a) aluno(a) <span style="font-weight:bold;text-decoration:underline;">`+estudante.nome+`</span> da <span style="font-weight:bold;text-decoration:underline;">`+estudante.classe+`</span> comprometo-me a cumprir com todas as obrigações do Regulamento Interno no Instituto Técnico Privado de Saúde Ilha da Verdade.</td></tr>
<tr>
  <td class="wordcenter negrito">Assinatura do Encarregado de Educação</td>
  <td></td>
  <td class="wordcenter negrito">Assinatura do Colabordor</td>
</tr>
<tr>
  <td class="bordaBottom"></td>
  <td></td>
  <td class="bordaBottom"></td>
</tr>
<tr>
  <td class="wordcenter">___/____/_____</td>
  <td></td>
  <td class="wordcenter">___/____/_____</td>
</tr>
<tr><td colspan="3">O processo de candidatura está pendente por falta dos seguintes documentos:______________________________________</td></tr>
<tr><td colspan="3" class="bordaBottom distanciaEntrelinhas"></td></tr>
<tr><td colspan="3" class="bordaBottom distanciaEntrelinhas"></td></tr>
<tr><td colspan="3">Notas: Todos os documentos passados pelas escolas privadas são provisórios e têm  a duração de 90 dias.<br>
  A matrícula é condicional durante 45 dias e até á apresentação de todos os doocumentos solicitados.</td></tr>

</table>
</div>

</body>
</html>
`
let options = {
            'format': 'A4',
            'border': { 'right': '5mm', 'left': '5mm' },
            'header': { 'height': '5mm' },
            'footer': { 'height': '5mm' }
          }

        this.gerarPDF(options)
      } catch (error) {
        console.log(error)
      }
    },
    async  gerarPDF (options) {
        this.isLoading = true
        try {
          await axios({
            method: 'post',
           // url: 'http://eftsl.softlineangola.com:8082/writefile',
           url: 'http://192.168.18.15:8085/writefile',
            data: {
              html: this.html,
              file_name: ls.get('nomeUsuario'),
              option: options
            }
          }).then()
          // Imprimir PDF
         this.frame()
        } catch (error) {
        }
      },
      frame () {
       let link = 'http://192.168.18.15:8085/readfile/'+ls.get('nomeUsuario')+'.pdf'
        let frame = `<html> +
        <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
        <body>
        <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
        </body></html>`
        let a = window.open('about:blank', '_blank', '', true)
        a.document.write(frame)
        a.document.close()
      },

     async  ObterHistoricoAcademico(params){
       try {
          return await axios.post('/ObterInscricaoTurmaEstudante',params)
        } catch (error) {
          Swal.fire('Informação','<p>Ocorreu um erro ao tentar efectuar a operação.</p>','warning')
       }

    },

    retornaData(data){
      let info = data.split('-')
      return info[2]+'-'+info[1]+'-'+info[0]
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axios.get('/cursoInstituicaoFindAllIntegracao').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally { 
        this.isLoading = false;
      }
    },

    outroDoc() {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = '';
        this.descricao = 'Nº do Bi';
        this.mascara = '#########-AA-###';
        this.ruleBI = [ value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'];
      } else {
        this.editedItem.bi = '';
        this.descricao = 'Outro Doc.';
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
        this.ruleBI = [ value => value.length >= 6 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'];
      }
    },

    async mudarNovoEstudante(item) {
      this.estudanteObjecto = item;
      this.dialogoConcordar = true;
    },
    
    showEditarDados(item) {
      this.editarDados= true
      this.editedItem = Object.assign(this.editedItem, item);
      this.editedItem.bi = item.nif;
      this.editedItem.numeroProcesso = item.numero_matricula;
      this.editedItem.matriculaAntiga = item.numero_matricula;
      this.editedItem.nomedamae = item.nomemae;
      this.editedItem.nomedopai = item.nomepai;
      let cursoObjecto = this.cursos.filter(c => c.idCurso === item.curso_id)[0]
      let provinciaObject = this.provincias.filter(p => p.descricao === item.provincia)[0]
      let municipioObject = this.municipiosAll.filter(m => m.descricao === item.municipio)[0]
      let sexoObject = this.dropdowSexo.filter(s => s.id === item.sexo)[0]
      this.editedItem.sexo = sexoObject;
      this.editedItem.provincia = provinciaObject;
      this.editedItem.municipio = municipioObject;
      this.editedItem.curso = cursoObjecto;
      this.loadclasseEditar((cursoObjecto === null || cursoObjecto === undefined) ? 5 : cursoObjecto.numero_anos_academicos, item.anoacademico);
      this.dialog = true;
    },

    async MudarTipoEstudante() {
      try {
        this.progresso = true;
        let resultado = await axios.post('/mudarTipoEstudante', { estudante: this.estudanteObjecto, tipo: 1 }).then(res => res.data);
        if (resultado.affectedRows >= 1) {
          this.dialogoConcordar = false;
          Swal.fire('Informação', '<p>Actualização efectuada com sucesso.</p>', 'success');
          this.initialize();
        }
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    async initializeClasses() {
      try {
        this.isLoading = true;
        this.classes = await axios.get('/classeFindAll2').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmasAll = await axios.get('/turmasFindAlls').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.isLoading = false;
      }
    },

    async initializeMunicipios() {
      try {
        this.progresso = true;
        this.municipiosAll = await axios.get('/municipioFindAll').then(res => res.data);
      } catch (error) {
        this.text = error;
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 });
      } finally {
        this.progresso = false;
      }
    },

    // METHODO FOR VALIDATION
    validate() {
      if (this.$refs.form.validate()) {
      } else {
        console.log('elso foraaa')
      }
    },
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    close() {
      this.dialog = false
      this.$refs.form.resetValidation()
    },
    saveDate(date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi
      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(datebi).toISOString().substr(0, 10)
    },

    async Save() {
      if (this.$refs.form.validate()) {
        this.overlay = true
        let params = {
          pk_estudante: this.editedItem.pk_estudante,
          nome: this.editedItem.nome,
          nif: this.editedItem.nif,
          morada: this.editedItem.morada,
          telefone1: this.editedItem.telefone,
          telefone2: this.editedItem.telefone2,
          email: this.editedItem.email,
          observacao: this.editedItem.observacao,
          produtosDesconto: null,
          descontoPorProduto: null,
          OpcaodescontoGlobal: null,
          descontoGlobal: null
        }

        try {
          //   let  payload =""
          let msg = await axios.post('/clienteInsertOrUpdate', params).then(res => res.data)
          if (msg) {
            this.initialize()
            this.showAlert()
            //this.Limpar()
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        } finally {
          this.overlay = false;
        }
      }
    },

    showAlert() {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Actualização efectuada com sucesso!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    Limpar() {
      this.editedItem.nome = '';
      this.editedItem.datanascimento = '';
      this.editedItem.nomedopai = '';
      this.editedItem.nomedamae = '';
      this.editedItem.dataemissaobi = '';
      this.editedItem.telefone = '';
    },

    openDialog() {
      this.dialog = true;
      this.editarDados = false
    },

    loadTurmaComb() {
      this.turmasFiltered = []
      this.editedItem.turma = null
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === this.editedItem.curso.idCurso && t.idAno_Academico === this.editedItem.classeSelected.id)
      console.log(this.turmasFiltered);
    },

    loadMunicipioComb(provincia) {
      this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia);
    },

    loadclasse() {
      /**
       * Nivel Ensino
       * 1 - Superioor
       * 2 - Médio
       */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(this.editedItem.curso.numero_anos_academicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    loadclasseEditar(numeroAnoAcademicos, anoacademicoEstudante) {
      /**
      * Nivel Ensino
      * 1 - Superioor
      * 2 - Médio
      */
      if (this.nivelEnsino === 1) {
        for (let index = 1; index <= parseInt(numeroAnoAcademicos); index++) {
          this.classesFiltered.push({ id: index, descricao: index + 'º ano' })
        }
        this.classesFiltered.push({ id: 100, descricao: 'Monografia' })
        this.editedItem.classeSelected = this.classesFiltered.filter(c => c.id === anoacademicoEstudante)[0]
      } else {
        let classe = 10
        for (let index = 1; index <= 4; index++) {
          this.classesFiltered.push({ id: index, descricao: classe + 'ª Classe' })
          classe++;
        }
      }
    },

    async Guardar() {
      if (this.$refs.form.validate()) {
        try {
          this.overlay = true;
          let params = {
            estudante: this.editedItem,
            nome: (this.editedItem.nome.length <= 0 || this.editedItem.nome === null) ? this.editedItem.nome : utilitarios.SetNameCapitalize(this.editedItem.nome.trim()),
            nomedopai: (this.editedItem.nomedopai.length <= 0 || this.editedItem.nomedopai === null) ? this.editedItem.nomedopai : utilitarios.SetNameCapitalize(this.editedItem.nomedopai.trim()),
            nomedamae: (this.editedItem.nomedamae.length <= 0 || this.editedItem.nomedamae === null) ? this.editedItem.nomedamae : utilitarios.SetNameCapitalize(this.editedItem.nomedamae.trim()),
            autor: ls.get('nomeUsuario'),
            turmaSelected: this.editedItem.turma,
            tipoEstudante: 0, // Estudante antigo, apeans não paga matricula
          }
           let result = await axios.post('estudanteInsertOrUpdate', params)
            if (result.data.affectedRows >= 1) {
               Swal.fire('Informação','Estudante cadastrado com sucesso','success')
              this.dialog = false;
              this.editedItem = this.defaultItem;
              this.initialize();
              this.editarDados = false
              this.$emit('fecharComponente', false);
            } else if (result.data.status === 1122) { // For duplicate entry
              Swal.fire('Informação', '<p>Número do Bilhete ou Processo já registrado.</p>', 'warning')
            } else {
              utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
            }
           
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao tentar efectuar a operação')
        } finally { 
          this.overlay = false; 
        }
      }
    },

    /**
     * Método responsavél por carregar os dados que serão necessário para registrar um bolseiro.
     * Trás a lista das organizações provedoras de bolsa disponivel
     * Trás a lista de todos os tipos de bolseiros salvo no Banco de dados
     * Caso houver um erro durante a requisição, será exibida uma notificação.
    */
    async carregarDadosBolseiros() {
      try {
        this.progresso = true;
        this.listaOngBolsas = await axios.get('/listarOrganizacoesBolsas').then((res) => res.data);
        this.listaOngBolsas.unshift({ nome: 'Nova Organização', id: -1, icone: true });
        this.tipoBolseiroOng = await axios.get('/obterDescricaoBolseiros').then((res) => res.data);
      } catch (error) {
        console.log(error)
        utilitarios.showAlertMessage('error', 'Ocorreu um error durante o carregamento da página!')
      } finally {
        this.progresso = false;
      }
    },

    /**
     * Método responsavél tornar o cardBolseiro visivél.
     * Armazena os dados do estudante selecionado na variavél bolseiroSelected
    */
    async registrarBolseiro(estudante) {
      this.cardBolseiro = true;
      this.bolseiroSelected = estudante;
    },

     /**
     * Método responsavél tornar o cardBolseiro invisivél.
     * Reseta o valor das variaveis tipoBolseiroSelected, valorDesconto, ongBolsaSelected
    */
    fecharCardBolseiro() {
      this.tipoBolseiroSelected = null;
      this.valorDesconto = '';
      this.descricaoBolseiro = '';
      this.ongBolsaSelected = null;
      this.mostrarOpcoesBolsa = false;
      this.cardBolseiro = false;
    },

    /**
     * Método responsavél tornar o cardNovaOrganizacao visivél.
     * Verifica se o usuário clicou na opcção "Nova Organização"
     * Reseta o valor da variavel ongBolsaSelected
     * Fecha o cardBolseiro
    */
    SelecionarOrganizacao() {
      this.mostrarOpcoesBolsa = false;
      if (this.ongBolsaSelected.tipo_bolseiro == 1) {
        this.tipoDeBolsa = 1;
        this.valorDesconto = "100%";
        this.descricaoBolseiro = "Os bolseiros dessa natureza são isentos de mensalidades e multas.";
      } else if(this.ongBolsaSelected.tipo_bolseiro == 2) {
        this.tipoDeBolsa = 2;
        this.valorDesconto = "0%";
        this.descricaoBolseiro = "Os bolseiros dessa natureza estão isentos do pagamento de multas decorrentes de atrasos no pagamento.";
      } else {
        this.tipoDeBolsa = 3;
        this.tipoBolseiroSelected = "Comparticipada";
        this.valorDesconto = "50%";
        this.descricaoBolseiro = "Os bolseiros desta natureza possuem direito a um desconto de 50% no pagamento da mensalidade.";
        this.mostrarOpcoesBolsa = true;
      }

      if (this.ongBolsaSelected.id === -1) {
        this.cardNovaOrganizacao = true;
        this.ongBolsaSelected = null;
        this.fecharCardBolseiro();
      }
    },

    /**
     * Método responsavel por verificar se a organização já foi cadastrada.
     * Verica se o nome quee está a ser inserido já existe no banco de dados
     * Valida se o campo está vázio
     * Se a organização já for cadastrada antes, será exibido uma notificação
     * Se ainda não foi cadstrada, será chamado o método responsavél por cadastrar
    */

    async verificarOrganizacao() {
      if (this.$refs.form.validate() && this.nomeNovaOrganizacao) {
        let params = {
          nome: this.nomeNovaOrganizacao.trim()
        }
        let organizacaoExistente = await axios.post('/verificarOrganizacaoExistente', params).then((res) => res.data);
        if (organizacaoExistente.length) {
          utilitarios.showAlertMessage('error', 'Organização já registrada!')
        } else {
          this.saveNovaOrganizacao();
        }
      }
    },

    /**
     * Método responsavél por cadastrar a nova organização inserida.
     * Se o cadastro ocrrer com sucesso, fecha o cardNovaOrganizacao e chamará a função this.carregarDadosBolseiros();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async saveNovaOrganizacao() {
      if (this.$refs.form.validate()) {
        let params = {
          tipo_bolseiro: this.idNovaOrganizacao.tipoBolseiro,
          nomeOrgazacao: this.nomeNovaOrganizacao.trim()
        }

        try {
          this.overlayOrganizacao = true;
          let result = await axios.post('/cadastrarNovaOrganizacao', params).then((res) => res.data);
          if(result.affectedRows >= 1) {
            utilitarios.showAlertMessage('success', 'Organização adicionada com sucesso!');
            this.fecharCardNovaOrganizacao();
            this.carregarDadosBolseiros();
            location.reload();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro ao adicionar a nova organização!')
        } finally {
          this.overlayOrganizacao = false;
        }
      }
    },

    /**
     * Método responsavél por fechar o cardNovaOrganizacao.
     * reseta o valor da variavél nomeNovaOrganizacao
    */
    fecharCardNovaOrganizacao() {
      this.nomeNovaOrganizacao = '';
      this.idNovaOrganizacao = null;
      this.cardNovaOrganizacao = false;
    },

    /**
     * Método responsavel por verificar se o bolseiro já foi cadastrado.
     * Verifica se o bilhete (nif) já existe na tabela bolseiros
     * Se o bolseiro já foi cadastrado antes, será exibido uma notificação
     * Se ainda não foi cadstrado, será chamado o método responsavél por cadastrar
    */
    async verificarBolseiroCadastrado() {
      if (this.$refs.form.validate()) {
        let params = {
          nif: this.bolseiroSelected.nif
        }
        let bolseiroExistente = await axios.post('/vericarBolseiroExistente', params).then((res) => res.data);
        if (bolseiroExistente.length) {
          utilitarios.showAlertMessage('error', 'Bolseiro já registrado!')
        } else {
          this.salvarBolseiro();
        }
      }
    },

    /**
     * Método responsavél por cadastrar umnovo bolseiro.
     * Se o cadastro correr com sucesso, fecha o fecharCardBolseiro e chamará a função this.initialize();
     * Caso ocorra um erro durante o cadastramento, será exibido uma notificação
    */
    async salvarBolseiro() {
      if (this.$refs.form.validate()) {
        let params = {
          nome: this.bolseiroSelected.nome,
          anoLectivo: this.bolseiroSelected.anolectivo,
          curso: this.bolseiroSelected.curso,
          nif: this.bolseiroSelected.nif,
          matricula: this.bolseiroSelected.numero_matricula,
          ongBolsa: this.ongBolsaSelected.nome,
          tipoBolsa: this.tipoDeBolsa,
          desconto: this.valorDesconto
        }
  
        try {
          this.overlay = true;
          let result = await axios.post('/registrarBolseiro', params).then((res) => res.data);
          if(result.affectedRows >= 0) {
            utilitarios.showAlertMessage('success', 'Bolseiro registrado com sucesso.')
            this.fecharCardBolseiro();
            this.initialize();
          }
        } catch (error) {
          utilitarios.showAlertMessage('error', 'Ocorreu um erro durante o registro do bolseiro!');
        } finally {
          this.overlay = false;
        }
      }
    },

    async ObterNumeroEstudantesTurma (){
      try {
        this.numeroEstudantesCadastrado = await axios.post('ObterNumeroIscritoEstudantesTurma',{turma:this.editedItem.turma}).then((res)=>res.data)
      } catch (error) {
        
      }
    }
  }
}
</script>
<style scoped>

.boldText{
   font-weight:bolder;
   font-size:15
   px;
}

.margin-card{
  margin-left:200px;
}

</style>
